// i18n/index.js

import { createI18n } from 'vue-i18n'
import { getI18NConf } from '@/lang/config'

export default createI18n(getI18NConf())